import { render } from "./SelectOption.vue?vue&type=template&id=22821687&scoped=true"
import script from "./SelectOption.vue?vue&type=script&lang=js"
export * from "./SelectOption.vue?vue&type=script&lang=js"

import "./SelectOption.vue?vue&type=style&index=0&id=22821687&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22821687"],['__file',"src/components/mdbvue/pro/Forms/SelectOption.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22821687"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22821687', __exports__)) {
    api.reload('22821687', __exports__)
  }
  
  module.hot.accept("./SelectOption.vue?vue&type=template&id=22821687&scoped=true", () => {
    api.rerender('22821687', render)
  })

}


export default __exports__